var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gwnl-dept-cell" },
    [
      _c(
        "yxt-popover",
        {
          attrs: {
            effect: "dark",
            trigger: "hover",
            placement: "top",
            disabled: _vm.deptName === "" || _vm.deptName === null,
            "show-scroll": "",
            "max-width": "300",
            "max-height": "200",
            "open-filter": true,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "ellipsis gwnl-dept-cell__label",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c("yxtbiz-dept-name", {
                class:
                  _vm.deptName === "" ||
                  _vm.deptName === null ||
                  _vm.deptName === undefined
                    ? "color-gray-6"
                    : "",
                attrs: {
                  name: _vm._f("emptyFormatter")(
                    _vm._f("deptNameFormatter")(_vm.deptName)
                  ),
                },
              }),
            ],
            1
          ),
          _c("yxtbiz-dept-name", {
            class:
              _vm.deptName === "" ||
              _vm.deptName === null ||
              _vm.deptName === undefined
                ? "color-gray-6"
                : "",
            attrs: { name: _vm.deptName },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }